import type { LocationQuery, RouteLocationRaw } from "vue-router"

export default function clearFiltersRouterLinkTo(routeQuery: LocationQuery, filters: { [key: string]: string }): RouteLocationRaw {
  const query: LocationQuery = {}

  Object.keys(routeQuery)
    .filter(param => !filters[param])
    .forEach((param) => {
      query[param] = routeQuery[param]
    })

  delete query.page_number

  return { query }
}
